import React from 'react';
import L from 'leaflet';

export default class LeafletSiteMarkerCircle extends L.CircleMarker {
  private siteMarkerInfo: any;
  private highlightedCriteriasRef: React.RefObject<any>;
  private handleSiteClicked: (event: L.LeafletMouseEvent) => void;

  constructor(
    siteMarkerInfo: any,
    highlightedCriteriasRef: React.RefObject<any>,
    handleSiteClicked: (event: L.LeafletMouseEvent) => void
  ) {
    super(siteMarkerInfo.location, {
      //fixed options
      stroke: false, // dnot draw border
      weight: 2, // line weight , used only for highlight
      color: 'red', // line color, used only for highlight
      opacity: 0.8,
      radius: 3.5,
      fillColor: 'black',
      fillOpacity: 0.8,
    });

    this.siteMarkerInfo = siteMarkerInfo;
    this.highlightedCriteriasRef = highlightedCriteriasRef;
    this.handleSiteClicked = handleSiteClicked;

    this.on('click', this.handleSiteClicked);
    this.on('pm:enable', (e: any) => e.target.pm.disable());
  }

  onAdd(map: L.Map) {
    super.onAdd(map);
    this.verifyHighlightCriteria();
    return this;
  }

  onRemove(map: L.Map) {
    super.onRemove(map);
    return this;
  }

  verifyHighlightCriteria() {
    // this.siteMarkerInfo.orientations is a Map so we use the values()
    // but since values() returns an iterator we cast ti to array since Firefox older versions than
    // 131 does not support the .some operator
    const needsHighlight = Array.from(
      this.siteMarkerInfo.orientations?.values() || []
    ).some((orientation: any) =>
      orientation.markers.some((cellMarkerInfo: any) =>
        this.highlightedCriteriasRef.current?.some(
          (highlightedCriteria: any) =>
            cellMarkerInfo[highlightedCriteria.id] &&
            cellMarkerInfo[highlightedCriteria.id] === highlightedCriteria.value
        )
      )
    );
    this.setStyle({
      stroke: needsHighlight,
    });
  }
}
